import React, { useEffect, useRef, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import axios from 'axios';
import { useAuth } from '../context/AuthContext';

const API = process.env.REACT_APP_BACKEND_URL;

export const AuthCallback = () => {
  const navigate = useNavigate();
  const { setUser } = useAuth();
  const hasProcessed = useRef(false);
  const [error, setError] = useState(null);

  useEffect(() => {
    if (hasProcessed.current) return;
    hasProcessed.current = true;
    const hash = window.location.hash;
    const match = hash.match(/session_id=([^&]+)/);
    if (!match) {
      navigate('/login', { replace: true });
      return;
    }
    const exchange = async () => {
      try {
        const { data } = await axios.post(`${API}/api/auth/session`, { session_id: match[1] }, { withCredentials: true });
        setUser(data);
        window.history.replaceState(null, '', window.location.pathname);
        navigate('/account', { replace: true, state: { user: data } });
      } catch {
        setError('Google sign-in failed. Please try again.');
      }
    };
    exchange();
  }, [navigate, setUser]);

  return (
    <div className="min-h-screen flex items-center justify-center bg-gray-50">
      {error ? (
        <div className="text-center">
          <p className="text-red-600 mb-4" data-testid="auth-callback-error">{error}</p>
          <a href="/login" className="text-emerald-600 underline">Back to login</a>
        </div>
      ) : (
        <div className="flex items-center gap-3 text-gray-600" data-testid="auth-callback-loading">
          <div className="w-6 h-6 border-2 border-emerald-500 border-t-transparent rounded-full animate-spin" />
          Signing you in…
        </div>
      )}
    </div>
  );
};
